import React, { Fragment, useState } from 'react';
import Caret from 'library/icons/caret.svg';
import { number, array, func, string, object } from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import SliderPanel from 'apps/journey/components/user-profile-setup/components/user-profile-setup-modal/components/slider-panel';
import * as StyledUserProfileModal from 'apps/journey/components/user-profile-setup/components/user-profile-setup-modal/styled-user-profile-setup-modal';
import * as StyledCareerClusterNavigation from 'apps/career-clusters/components/career-clusters-survey/survey-sections/styled-career-cluster-navigation';

const CareerClustersModalNavigation = ({ categories=[], match }) => {
  const page = Number(resolve(match, 'params/page', '0'));
  const [listViewActive, togglelistViewActive] = useState(false);

  const mapQuestionIndicator = ({ id, title }) => {
    if (title == 'Complete') return null;

    return <StyledCareerClusterNavigation.StyledQuestionIndicator current={id <= page} key={id} />;
  };

  const mapGroupList = ({ title, id }) => {
    if (title == 'Complete') return null;

    return (
      <StyledUserProfileModal.StyledListItem current={id <= page} key={id}>
        <div key={id} />
        <span> {title}</span>
      </StyledUserProfileModal.StyledListItem>
    );
  };

  mapQuestionIndicator.propTypes ={
    title: string,
    id: number
  };

  mapGroupList.propTypes = {
    title: string,
    id: number
  };

  return (
    <Fragment>
      {
        !listViewActive &&
    <StyledCareerClusterNavigation.StyledNavigation>
      <StyledCareerClusterNavigation.StyledNavigationLink
        disabled={page == 1}
        to={{
          pathname: page == 1 ? '/1' : `/${Math.max(0, page-1)}`,
          state: { direction: 'backward' }}}>
        Back
      </StyledCareerClusterNavigation.StyledNavigationLink>
      <StyledCareerClusterNavigation.StyledCategoryIndicator>
        <StyledCareerClusterNavigation.StyledCategoryToggleButtton onClick={() => togglelistViewActive(true)}>
          <Caret /> view questions
        </StyledCareerClusterNavigation.StyledCategoryToggleButtton>
        <div className="indicator">
          {categories.map(mapQuestionIndicator)}
        </div>
      </StyledCareerClusterNavigation.StyledCategoryIndicator>
      <StyledCareerClusterNavigation.StyledNavigationLink to={{
        pathname: `/${page + 1}`,
        state: { direction: 'forward' }}}>
        { page == 3 ? 'Complete' : 'Next'}
      </StyledCareerClusterNavigation.StyledNavigationLink>
    </StyledCareerClusterNavigation.StyledNavigation>
      }
      <SliderPanel listViewActive={listViewActive}>
        <StyledCareerClusterNavigation.StyledCloseCategoryToggle>
          <StyledCareerClusterNavigation.StyledCategoryToggleButtton onClick={() => togglelistViewActive(false)}>
            Close <Caret />
          </StyledCareerClusterNavigation.StyledCategoryToggleButtton>
        </StyledCareerClusterNavigation.StyledCloseCategoryToggle>
        <h3> Career Cluster Survey </h3>
        <StyledUserProfileModal.StyledQuestionList>
          {categories.map(mapGroupList)}
        </StyledUserProfileModal.StyledQuestionList>
      </SliderPanel>
    </Fragment>
  );
};

CareerClustersModalNavigation.propTypes = {
  ittr: number,
  categories: array,
  ittrManager: func,
  match: object
};

export default CareerClustersModalNavigation;
